import * as React from 'react';
import { useSelector } from 'react-redux';

import { userLocaleFetcher } from '@app/services/translations';
import { selectLocale } from '@app/redux';

export const I18nLocaleProvider: React.FC<React.PropsWithChildren> = (props) => {
  const {
    locale: { userLocale },
  } = useSelector(selectLocale);

  React.useEffect(() => {
    userLocaleFetcher.init(() => userLocale);
  }, [userLocale]);

  if (!userLocale) {
    return null;
  }

  return <>{props.children}</>;
};
